import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { stashHandoff } from './use-copilot';
import { copilotRouteFor } from '../model/copilot-paths';
import { isRouteAction, isSafeInternalPath } from '../model/route-action';
import { hasInitialOnboarding } from '../model/onboarding';

export default function useRouteAction({ scope, appId, accountId }, { followSameScope = false, enabled = true } = {}) {
    const navigate = useNavigate();
    const location = useLocation();
    const onboarding = Boolean(appId) && new URLSearchParams(location.search).get('onboarding') === '1'
        && (hasInitialOnboarding(appId) || location.state?.initialOnboardingAppId === appId);
    return useCallback(action => {
        if (!enabled || onboarding || !isRouteAction(action) || !isSafeInternalPath(action.path)) return;
        const next = copilotRouteFor(action.path, scope, accountId);
        if (!next) {
            // Only the persistent workspace can carry the live conversation into an editor.
            if (followSameScope && action.path !== `${location.pathname}${location.search}${location.hash}`) {
                navigate(action.path, { state: { fromCopilot: true } });
            }
            return;
        }
        if (action.handoffMessage) stashHandoff(next.scope, action.handoffMessage);
        navigate(next.path);
    }, [navigate, scope, accountId, onboarding, enabled, followSameScope, location.pathname, location.search, location.hash]);
}
